import type { Props as ButtonProps } from '@sorare/core/src/atoms/buttons/Button';
import { FilterButton } from '@sorare/core/src/components/search/FilterButton';
import { useGQLSearchContext } from '@sorare/core/src/contexts/graphql-search';

import { useFiltersCount } from 'search/FiltersManager/useFiltersCount';

interface ToggleFiltersManagerProps {
  toggleFilters: () => void;
  color?: ButtonProps['color'];
  size?: ButtonProps['size'];
}

export const ToggleFiltersManager = ({
  toggleFilters,
  color,
  size,
}: ToggleFiltersManagerProps) => {
  const filtersCount = useFiltersCount();
  return (
    <FilterButton
      onClick={() => {
        toggleFilters();
      }}
      filtersCount={filtersCount}
      color={color}
      size={size}
    />
  );
};

export const BackendToggleFiltersManager = ({
  toggleFilters,
  color,
  size,
}: ToggleFiltersManagerProps) => {
  const { activeFacets } = useGQLSearchContext()!;
  const filtersCount = Object.keys(activeFacets).length;
  return (
    <FilterButton
      onClick={() => {
        toggleFilters();
      }}
      filtersCount={filtersCount}
      color={color}
      size={size}
    />
  );
};
